<template>
  <div class="c-department-add-users">
    <div class="department-window">
      <n-card class="department-card">
        <n-loader :loading="$var('load')" />
        <div class="card-top">
          <n-button flat @click="closeModal">X</n-button>
        </div>
        <div class="users">
          <div class="department-info">
            <div v-for="item in users" :key="item.id" class="user">
              <label class="user-label">
                <input v-model="selected" type="checkbox" class="user-check" :value="item">
                <span class="user-full-name">{{ (item.firstname || '') + ' ' + (item.name || '') + ' '+ (item.surname || '') }}</span>
              </label>
            </div>
          </div>
          <div class="button-save">
            <n-button color="primary" @click="save">Сохранить</n-button>
          </div>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CDepartmentAddUsers',
  props: {
    id: {
      type: Number,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      users: [],
      selected: [],
    }
  },
  watch: {
    selected() {
    },
  },
  created() {
    this.load()
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false)
    },
    load() {
      this.$var('load', true)
      $api.users.getFree(this.companyId).all().with('users').then((response) => {
        $n.each(response.data.content, (e) => {
          this.users.push({
            ...e,
          })
        })
      }).finally(() => {
        this.$var('load', false)
      })
      this$.var('load', false)
    },
    save() {
      this.$var('load', true)
      const users = $n.map(this.selected, (e) => {
        return { userId: e.id, }
      })
      $api.branches.addUsers(this.companyId, this.id, users).then(() => {
        this.closeModal()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.user-label {
  padding: 10px;
  margin-bottom: 15px;
  .user-check {
    width: 24px;
    height: 24px;
  }
  .user-full-name {
    font-size: 1.3em;
  }
}
.c-department-add-users {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  max-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .2);

  .button-save {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }

  .department-card {
    ::v-deep .content {
      max-height: 90vh;
    }
  }
  .card-top {
    display: flex;
    align-items: center;
    justify-content: right;
  }
}
</style>
